import { FETCH_TRANSACTIONS_PER_PAGE_COUNT } from '@bo-constants/member/members';
import type { MemberTransactionFilters } from '@library/types/members/memberTransactions';
import { useGetMemberTransactionsQuery } from '@bo-services/members/memberTransactionsApi';

import { useParams } from 'react-router-dom';

export const useMemberTransactionsTable = ({
  currentPage,
  memberTransactionFilters
}: {
  currentPage: number;
  memberTransactionFilters: MemberTransactionFilters;
}) => {
  const { memberId } = useParams<{ memberId?: string }>();
  const { transactionDate, transactionTypes = [] } = memberTransactionFilters;

  const { data, isError, isFetching, isLoading } =
    useGetMemberTransactionsQuery(
      {
        createdAt: transactionDate
          ? transactionDate.toISOString().slice(0, 10)
          : '',
        memberId,
        page: currentPage,
        perPage: FETCH_TRANSACTIONS_PER_PAGE_COUNT,
        transactionTypes: transactionTypes.join(',') || ''
      },
      {
        skip: !memberId
      }
    );

  const isTransactionsLoading = isFetching || isLoading;
  const { memberTransactions = [], totalPages = 0 } = data || {};

  return {
    currentPage,
    isError,
    isLoading: isTransactionsLoading,
    memberTransactions,
    totalPages
  };
};
